import React, { useRef } from "react";
import { MdMarkEmailRead } from "react-icons/md";
import { BsFillTelephoneForwardFill } from "react-icons/bs";
import { GoLocation } from "react-icons/go";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const Contact = () => {
  const form = useRef();

  // contact with email js

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_hpz76dq",
        "template_hmdqgsh",
        form.current,
        "L3eStQmcpFvpPjUkf"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success("Successfully send message");
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <div>
      <div>
        <div className="hero min-h-screen">
          <div className="hero-content flex-col lg:flex-row-reverse gap-20 mx-auto ">
            <div
              data-aos="zoom-in-up"
              data-aos-duration="7000"
              className="lg:text-left text-white grid grid-cols-1 items-center justify-center"
            >
              <h1 className="text-3xl text-pink-700 font-bold">
                Contact With Me
              </h1>
              <p className="py-6 text-xl">
                if you need any projects help , please send me an email.{" "}
              </p>
              <div className="flex flex-col item-center justify-center">
                <div className="flex items-center">
                  <span>
                    {" "}
                    <GoLocation className="text-3xl font-bold text-orange-600 mr-4" />{" "}
                  </span>
                  <span className="text-xl">
                    Mohammadpur , Dhaka-120, Bangladesh
                  </span>
                </div>

                <div className="flex items-center">
                  <span>
                    <MdMarkEmailRead className="text-3xl font-bold text-orange-600 mr-4" />
                  </span>
                  <span className="text-xl mb-4">
                    alamin.sarker4241@gmail.com
                  </span>
                </div>
                <div className="flex items-center">
                  <span>
                    <BsFillTelephoneForwardFill className="text-3xl text-orange-600 font-bold mr-4" />
                  </span>
                  <span className="text-xl"> +8801740051568</span>
                </div>
              </div>
            </div>
            <div
              data-aos="flip-right"
              data-aos-duration="8000"
              data-aos-delay="2"
              className="card mt-4 flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100"
            >
              <form
                ref={form}
                onSubmit={sendEmail}
                className="card-body text-orange-600"
              >
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Name</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    name="name"
                    className="input input-bordered"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    type="email"
                    placeholder="email"
                    name="email"
                    className="input input-bordered"
                  />
                </div>
                {/* <div className="form-control">
                  <label className="label">
                    <span className="label-text">Subject</span>
                  </label>
                  <input
                    type="text"
                    placeholder="subject"
                    name="subject"
                    className="input input-bordered"
                  />
                </div> */}
                <div className="form-control">
                  <textarea
                    className="textarea textarea-secondary"
                    placeholder="your Message"
                    name="message"
                  ></textarea>
                </div>
                <div className="form-control mt-6">
                  <input
                    className="btn btn-success"
                    type="submit"
                    value="Send"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="text-white py-4 px-20">
        <hr className="text-2xl" />
      </div>
    </div>
  );
};

export default Contact;
